const apiUrl = `${window.location.protocol}//${window.location.hostname}/api`;

export const customerAuth = {
    login: async (email, password) => {
        const response = await fetch(`${apiUrl}/portal/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password })
        });
        const data = await response.json();
        if (response.ok && data.auth) {
            localStorage.setItem('customer_token', data.token);
            localStorage.setItem('customer_user', JSON.stringify(data.user));
            return data;
        }
        throw new Error(data.message || 'Login failed');
    },

    register: async (email, password, contactName, customerId) => {
        const response = await fetch(`${apiUrl}/portal/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password, contact_name: contactName, customer_id: customerId })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Registration failed');
        return data;
    },

    logout: () => {
        localStorage.removeItem('customer_token');
        localStorage.removeItem('customer_user');
    },

    getToken: () => localStorage.getItem('customer_token'),

    getUser: () => {
        const user = localStorage.getItem('customer_user');
        return user ? JSON.parse(user) : null;
    },

    isAuthenticated: () => !!localStorage.getItem('customer_token'),

    fetchWithAuth: async (path, options = {}) => {
        const token = localStorage.getItem('customer_token');
        const response = await fetch(`${apiUrl}${path}`, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token,
                ...options.headers
            }
        });
        if (response.status === 401 || response.status === 403) {
            localStorage.removeItem('customer_token');
            localStorage.removeItem('customer_user');
            window.location.href = '/customer/login';
            throw new Error('Session expired');
        }
        return response;
    }
};
